const mutations = {
  SET_FEATURE_FLAGS(state, newState) {
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
};

export default mutations;
